/**
 * 加药状态
 */

import {
    Style
} from '@/libs/style.js';

let template = /*html*/ `
<div class="chemical-status">
    <div class="chemical-status-header">
        <!--<img src="./images/default/2.png" alt="">-->
        <h2>加药统计</h2>
        <dv-decoration-1 style="width:200px;height:100%;position:absolute;right:0;" />
    </div>
    <!--<dv-conical-column-chart-1 :config="JSON.stringify(config)" style="height:100%;" />-->
    <dv-charts :option="option" />
</div>`;


let style = /* css */ `.chemical-status{
    position: absolute;
    top: 33%;
    right: 1%;
    width: 25%;
    height: 30%;
    overflow: hidden;
}

.chemical-status .chemical-status-header{
    padding-left:15px;
    background:linear-gradient(to right,#159AFF80,rgba(0,0,0,0) 100%);
    height: 50px;
    color: #fff;
    display:flex;
    align-items:center;
    position:relative;
}
.chemical-status .chemical-status-header img{
    margin:0 15px;
}
`;

export default (Vue) => {
    Vue.customElement('xbt-chemical-status-monitoring', {
        template: template,
        data() {
            return {
                option: {
                    colors:['#ffffff','#2BC6E9'],
                    title: {
                        text: '',
                        show: false
                    },
                    legend: {
                        data: ['PAC', 'PAM', '碳源', '次杨酸钠'],
                        top: 40,
                        textStyle: {
                            fill: '#fff'
                        }
                    },
                    xAxis: {
                        name: '',
                        data: ['1月', '2月', '3月',]
                    },
                    grid: {
                        bottom: '30%',
                        style: {
                            fill: 'rgba(0, 0, 0, 0)',
                        }
                    },
                    yAxis: {
                        data: 'value',
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        nameTextStyle: {
                            fill: '#fff',
                            fontSize: 10
                        }
                    },
                    series: [
                        {
                            name: 'PAC',
                            data: [94, 100, 80, 70, 120, 85, 76],
                            type: 'bar',
                            fill: {
                                show: true
                            },
                            
                        },
                        {
                            name: 'PAM',
                            data: [90, 50, 90, 70, 67, 99, 103],
                            type: 'bar',
                            smooth: true,
                            
                        },
                        {
                            name: '碳源',
                            data: [70, 90, 80, 100, 110, 78, 96],
                            type: 'bar',
                        },
                        {
                            name: '次氯酸钠',
                            data: [102, 92, 87, 77, 85, 65, 66],
                            type: 'bar',
                        }
                    ]
                },
                config: {
                    data: [{
                        name: 'PAC',
                        value: 55
                    },
                    {
                        name: 'PAM',
                        value: 120
                    },
                    {
                        name: '碳源',
                        value: 71
                    },
                    {
                        name: '次杨酸钠',
                        value: 90
                    }
                    ],
                    showValue: true,
                }
            }
        },
        created() {
            this.mock = this.$Core.getProvider('Mock')
            this.init()
        },
        mounted() {
            Style(style);
        },
        methods: {
            async init() {
                let data = await this.mock.getPACStatistics()
              

                let options = {
                    color:['#ffffff','#2BC6E9','#327CFF','#4FAC44'],
                    title: {
                        text: '',
                        show: false
                    },
                    legend: {
                        data: [],
                        top: 40,
                        textStyle: {
                            fill: '#fff'
                        }
                    },
                    xAxis: {
                        name: '',
                        data: []
                    },
                    grid: {
                        bottom: '30%',
                        style: {
                            fill: 'rgba(0, 0, 0, 0)',
                        }
                    },
                    yAxis: {
                        data: 'value',
                        splitLine: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        nameTextStyle: {
                            fill: '#fff',
                            fontSize: 10
                        }
                    },
                    series: []
                }
                // 获取当前日期
                let date = new Date().getDate()
                let statisticsData = []
                for (let i = 1; i <= 5; i++) {
                    let st = data[date - i]
                    if (st) {
                        statisticsData.push(st)
                    }
                }

                statisticsData.reverse()
                statisticsData.forEach((element, index) => {
                    if (index == 0) {
                        // options.legend.data = []
                        element.data.forEach(item => {
                            // 设置显示的菜单
                            options.legend.data.push(item.label)
                            let series = {
                                name: item.label,
                                data: [],
                                type: 'bar',
                                fill: {
                                    show: true
                                },
                            }
                            options.series.push(series)
                        })
                    }
                    options.xAxis.data.push(element.date + '日')

                    // 设置series值
                    options.series.forEach(item => {
                        let obj = element.data.find(i => i.label == item.name)
                        item.data.push(obj.value)

                    })
                });

                this.option = options;
            }
        }
    });
}